import React, {useEffect, useState} from 'react';
import {Button} from '../../components/Button';
import {DirectoryBar} from '../../components/DirectoryBar';
import {H6} from '../../components/H6';
import {InfoSection} from '../../components/MyPage/InfoSection';
import {ProductSection} from '../../components/MyPage/ProductSection';
import {ShippingInfoSection} from '../../components/MyPage/ShippingInfoSection';
import {PopUp} from '../../components/PopUp';
import {Section} from '../../components/Section';
import {Table} from '../../components/Table';
import {useHistory, useParams} from "react-router-dom";
import {getOrderHistoryDetail, orderCancel, orderRequestPrePaid} from "../../apis/orders";
import {
    CancelOrderProduct,
    OrderCancelRequest,
    OrderPaidProduct, OrderRequestPrepaidDto,
    OrderRequestRequestDto,
    TOrderDetail
} from "../../types/types";
import PaymentInfoPC from "../../components/PaymentInfoPC";
import PaymentInfoMobile from '../../components/PaymentInfoMobile';
import {nToast} from "../../plugins/reactToast";
import OrderNumberSection from "../../components/OrderNumberSection";
import {AccountSection} from "../../components/MyPage/AccountSection";
import {Bridge} from "../../plugins/bridge";
import {BRAZE_EVENT} from "../../constants/braze";
import {swapPayMethod} from "../../utils/texts";
import { MyPageEventProperties } from '../../types/amplitudeEventProperties';
import { AIRBRIDGE_EVENT } from '../../constants/airbridge';
import { isMobile } from 'react-device-detect';
import {iamportPaymentCancel} from "../../apis/iamport";
import {Select} from "../../components/Select";
import {TextField} from "../../components/TextField";
import {getUserInfo} from "../../apis/user";

export const MyPageOrdersCancel = () => {
    const [popUp, setPopUp] = useState(false);
    const {orderNumber} = useParams<{ orderNumber: string }>()
    const [order, setOrder] = useState<TOrderDetail>()
    const history = useHistory()
    const [refundAccount, setRefundAccount] = useState<{ refundAccountBank?: string, refundAccountNumber?: string }>()
    // @ts-ignore
    const {
        nOrder,
        products,
    }: { nOrder: TOrderDetail; products: OrderPaidProduct[] } = history.location.state;
    const [cancelProducts, setCancelProducts] = useState<CancelOrderProduct[]>();
    const [prePaid, setPrePaid] = useState<OrderRequestPrepaidDto>()

    /*
    *   MEMO: nOrder -> 비회원 주문 처리용
    * */

    useEffect(() => {
        let list: number[] = []
        products.forEach((item) => list.push(item.orderProductId))
        let data: OrderRequestRequestDto = {
            customerName: undefined,
            customerPhone: undefined,
            orderProductIds: list,
            orderRequestType: 'CANCEL'
        }
        if (nOrder) {
            data.customerName = localStorage.getItem('customerName') || '';
            data.customerPhone = localStorage.getItem('customerPhone') || '';
            setOrder(nOrder)
        } else {
            getOrderHistoryDetail(orderNumber).then(r => setOrder(r.data.payload))
        }
        orderRequestPrePaid(orderNumber, data).then(r => setPrePaid(r.data.payload)).catch(e => console.log(e))
    }, [orderNumber])

    useEffect(() => {
        setCancelProducts(products.map(product => {
            return ({
                cancelOrderProductId: product.orderProductId,
                cancelReason: '',
            })
        }))
    }, [products])

    if (!order || !cancelProducts) return null

    const checkReason = () => {
        console.log(cancelProducts)
        cancelProducts.find(product => product.cancelReason === '') ? nToast('취소 사유를 선택해 주세요') : submitCancel()
    }

    const submitCancel = () => {
        const data: OrderCancelRequest = {}
        data.cancelOrderProducts = cancelProducts.map(product => {
            return ({
                cancelOrderProductId: product.cancelOrderProductId,
                cancelReason: product.cancelReason,
            })
        })
        if (nOrder) {
            data.customerName = order.customerName
            data.customerPhone = order.customerPhone
        }
        if (order.payMethod === 'VIRTUAL_ACCOUNT' && order.status !== 'WAIT') {
            if (refundAccount?.refundAccountNumber && refundAccount.refundAccountBank) {
                data.bankOwner = order.customerName
                data.bankNumber = refundAccount?.refundAccountNumber
                // @ts-ignore
                data.bankCode = refundAccount?.refundAccountBank
            } else {
                nToast('환불받으실 계좌 정보를 입력해 주세요')
                return;
            }
        }
        iamportPaymentCancel(orderNumber, data).then(r => {
            Bridge.sendAirbridge(AIRBRIDGE_EVENT.orderCancel, {
                action: "취소",
                value: order?.totalPrice,
                semanticAttributes: {
                    transactionID: order?.orderId,
                    inAppPurchased: isMobile,
                    totalValue : order?.totalPrice,
                    currency: "KRW",
                    totalQuantity: order?.products.map(product => product.count).reduce((a, b) => a + b, 0),
                    products: order?.products
                }
            })
            // Bridge.sendBraze(BRAZE_EVENT.ORDER_CANCELLED, {
            //     non_member_order: !!nOrder,
            //     item_id: order.orderId,
            //     item_name: order.products.map(p => p.productName).join(','),
            //     item_category: undefined,
            //     item_color: order.products.map(p => p.color).join(','),
            //     item_gender: undefined,
            //     item_size: order.products.map(p => p.sizeName).join(','),
            //     item_price: order.products.map(p => p.unitPrice).join(','),
            //     item_discount_rate: order.products.map(p => (1 - p?.discountedUnitPrice! / p?.unitPrice!) * 100).join(','),
            //     item_discount_price: order.products.map(p => p.discountedUnitPrice).join(','),
            //     order_item_quantity: order.products.map(p => p.count).join(','),
            //     total_order_items_quantity: order?.products.map(product => product.count).reduce((a, b) => a + b, 0),
            //     sub_total: order?.productPrice,
            //     payment_method: swapPayMethod(order?.payMethod!),
            //     paid_shipping: order?.deliveryPrice,
            //     paid_point: order?.usedMileage,
            //     coupon_id: order?.appliedCoupons?.map(c => c.couponId).join(','),
            //     coupon_name: order?.appliedCoupons?.map(c => c.name).join(','),
            //     reward_point: order?.earnedMileage,
            //     order_id: order?.orderId,
            //     order_total: order?.totalPrice,
            // })
            nToast(`주문 취소가 완료되었습니다.`);
            if (nOrder) {
                history.goBack()
            } else {
                history.replace('/mypage/cancels')
            }
        })
            .catch(() => {
                nToast('배송이 시작된 주문은 취소할 수 없습니다. 자세한 문의는 채널톡으로 문의 부탁드립니다.')
            })
    }

    return (
        <>
            <PopUp
                title="정말 주문을 취소하시겠습니까?"
                buttonText="취소하기"
                open={popUp}
                onClose={() => setPopUp(false)}
                onClick={checkReason}
                onClickMobile={checkReason}
            />

            <DirectoryBar text="주문 취소" backArrow className="md:hidden"/>

            <div className={nOrder ? "md:mx-auto md:my-30 max-w-screen-xl space-y-14" : "space-y-14"}>
                <Section className="space-y-4 text-13">
                    <div className="border-b pb-2">
                        <H6>주문 취소</H6>
                    </div>
                    <OrderNumberSection orderNumber={order.orderNumber} orderedAt={order.orderedAt!}/>
                </Section>

                {/* Desktop ProductSection */}
                <ProductSection hideActions={true}
                                className="hidden md:block"
                                order={order}
                                content={
                                    <>
                                        <Table className="mt-5">
                                            <Table.Head>
                                                <Table.Row>
                                                    <Table.Th>상품</Table.Th>
                                                    <Table.Th>사이즈</Table.Th>
                                                    <Table.Th>적립금 적립</Table.Th>
                                                    <Table.Th>결제금액</Table.Th>
                                                    <Table.Th>취소사유</Table.Th>
                                                </Table.Row>
                                            </Table.Head>
                                            <Table.Body>
                                                {products.map((product, index) => (
                                                    <Table.Row key={index}>
                                                        <Table.Td>
                                                            <div className="flex space-x-4 font-normal items-center">
                                                                <div
                                                                    className="w-20 h-28 relative rounded-md overflow-hidden">
                                                                    <img
                                                                        src={product.thumbnailUrl}
                                                                        alt=""
                                                                        className="w-full h-full object-cover absolute"
                                                                    />
                                                                </div>
                                                                <div className="space-y-2 text-10 font-semibold">
                                                                    <p className="whitespace-normal">
                                                                        {product.productName}
                                                                        <br/>
                                                                        <span
                                                                            className="text-brand-3">{product.color}</span>
                                                                    </p>

                                                                    <p className="text-brand-3">{product.unitPrice.toLocaleString()}원/수량{product.count}개</p>
                                                                </div>
                                                            </div>
                                                        </Table.Td>

                                                        <Table.Td>{product.sizeName}</Table.Td>
                                                        <Table.Td>{product.earnedMileage.toLocaleString()}원</Table.Td>
                                                        <Table.Td className="font-bold">
                                                            {product.totalPrice.toLocaleString()}원
                                                        </Table.Td>
                                                        <Table.Td>
                                                            <CancelReasonSelector product={product}
                                                                                  onSelect={(orderProductId: number, selectItem: string) => {
                                                                                      const products = [...cancelProducts]
                                                                                      const target = products.find((product) => product.cancelOrderProductId === orderProductId)
                                                                                      target!.cancelReason = selectItem
                                                                                      setCancelProducts([...products])
                                                                                  }}/>
                                                        </Table.Td>
                                                    </Table.Row>
                                                ))}
                                            </Table.Body>
                                        </Table>

                                        <p className="border-t border-gray-200 pt-4 flex flex-row-reverse text-12 text-gray-500">
                                            *적립금 적립율 변동 시, 기간별 적립 적립금이 상이 할 수
                                            있습니다.
                                        </p>
                                    </>
                                }
                />

                {/* Mobile ProductSection */}
                <ProductSection
                    className="md:hidden"
                    order={order}
                    content={
                        <>
                            {products.map((product, index) => (
                                <div className="flex space-x-2 border-b pb-4 pt-2" key={index}>
                                    <img
                                        src={product.thumbnailUrl}
                                        alt=""
                                        className="wh-16"
                                    />

                                    <div className="flex-1 text-13">
                                        <p className="">
                                            {product.productName} <br/>
                                            {product.color}
                                        </p>
                                        <p className="pt-3">{product.unitPrice.toLocaleString()}원
                                            /수량 {product.count}개</p>
                                    </div>

                                    <div className="font-bold text-right">
                                        <p className="">{product.totalPrice.toLocaleString()}원</p>
                                        <p className="pt-4">{product.sizeName} size</p>
                                        <p className={`text-13 font-normal mb-2 mt-6`}>취소사유</p>
                                        <CancelReasonSelector product={product}
                                                              onSelect={(orderProductId: number, selectItem: string) => {
                                                                  const products = [...cancelProducts]
                                                                  const target = products.find((product) => product.cancelOrderProductId === orderProductId)
                                                                  target!.cancelReason = selectItem
                                                                  setCancelProducts([...products])
                                                              }}
                                        />
                                    </div>
                                </div>
                            ))}
                        </>
                    }
                />
                <InfoSection name={order.customerName!} phone={order.customerPhone!}/>

                <ShippingInfoSection hideActions order={order}/>

                {(order.payMethod !== 'CARD' && order.payMethod !== 'KAKAO' && order.payMethod !== 'NAVER') && (
                    <AccountSection order={order}
                                    onChangeAccount={(accountInfo) => setRefundAccount(accountInfo)}
                    />
                )}

                {/* Desktop 결제 정보 Section */}
                <Section className="hidden md:block text-13">
                    <H6 className="border-b pb-2">취소 정보</H6>

                    <PaymentInfoPC order={order} prepaid={prePaid}/>

                    <div className="flex flex-row-reverse pt-8">
                        <Button
                            onClick={() => setPopUp(true)}
                            text="주문 취소하기"
                            className="filled-brand-1 px-16"
                        />
                    </div>
                </Section>

                {/* Mobile 결제 정보 Section */}
                <Section className="md:hidden text-13">
                    <div className="border-b pb-2 mb-4 flex justify-between items-center">
                        <H6 className="">취소 정보</H6>

                    </div>

                    <PaymentInfoMobile order={order} prepaid={prePaid}/>
                    <div className="flex flex-row-reverse pt-8">
                        <button className="filled-brand-1 rounded-md px-3 py-2 "
                                    onClick={() => setPopUp(true)}
                            >
                                주문 취소하기
                            </button>
                    </div>
                </Section>
            </div>
        </>
    );
};


type CancelReasonSelectorProps = {
    product: OrderPaidProduct,
    onSelect: (orderProductId: number, selectItem: string) => void,
}
const CancelReasonSelector = (props: CancelReasonSelectorProps) => {
    const {product, onSelect} = props;
    const [showMoreReason, setShowMoreReason] = useState(false);

    const CancelReasons = ['단순변심', '배송지연', '상품정보 상이', '서비스 불만족', '기타사유'];

    return(
        <div className={'space-y-3'}>
            <Select className="border border-gray-100 pl-4"
                    onChange={e => {
                        if (e.target.value === '기타사유') {
                            setShowMoreReason(true);
                        } else {
                            setShowMoreReason(false);
                        }
                        onSelect(product.orderProductId, e.target.value);
                    }}>
                <option hidden={true} value={''}>
                    취소사유
                </option>
                {CancelReasons.map((item, index) => (
                    <option key={index} value={item}>
                        {item}
                    </option>
                ))}
            </Select>
            <TextField className={`border-gray-100 ${showMoreReason ? '' : 'hidden'}`}
                       placeholder={`사유를 입력해주세요.`}
                       onChange={(e) => {
                       //     do something
                       }}
            />
        </div>
    )
}
